class Buttons {
	constructor() {
		const buttons = document.querySelectorAll(".btn");
		const buttonsLight = document.querySelectorAll(".btn-light");

		const svg =
			`<svg width="15" height="13" viewBox="0 0 15 13" xmlns="http://www.w3.org/2000/svg">
				<path d="M8.33683 13L15 6.5L8.33683 -2.91256e-07L6.39475 1.89452L9.75791 5.15993L7.28127e-07 5.15992L6.10979e-07 7.83997L9.75791 7.83997L6.39475 11.1054L8.33683 13Z" />
			</svg>`;

		buttons.forEach(btn => {
			const text = btn.innerHTML;
			btn.innerHTML = `<span>${text}</span>`;
		});

		buttonsLight.forEach(btn => {
			const text = btn.innerHTML;
			btn.innerHTML = `<span>${text}</span>`;

			if (!btn.classList.contains("no-arrow")) {
				btn.insertAdjacentHTML("beforeend", svg);
			}
		});
	}
}